module.exports = __webpack_public_path__ + "assets/img/3509-pg.svg";